import BlockingSvg from 'assets/icons/Blocking.svg?react';

import { createAntdIcon } from 'components/icons/createAntdIcon';

export default createAntdIcon(BlockingSvg, { displayName: 'BlockingOutlined' });
